import { faCaretDown, faCaretRight, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { InputText } from 'primereact/inputtext'
import { useState } from 'react'

const InputRefiner = props => {
    const [isShow, setIsShow] = useState(false)

    const {
        refinerLabel,
        refinerId,
        refiners,
        placeHolder,
        minLength = 3,
        onSubmitValue,
        onClickRemoveRefinerGroup,
    } = props

    const [inputValue, setInputValue] = useState(
        () => refiners.find(i => i.Id === refinerId)?.Value ?? ''
    )

    const submitValue = () => {
        const trimmedValue = inputValue.trim()

        if (trimmedValue.length === 0) {
            // Only remove (and hit the API) when a filter for this refiner actually exists
            if (refiners.some(i => i.Id === refinerId)) {
                onClickRemoveRefinerGroup(refinerId)
            }
            return
        }

        if (trimmedValue.length < minLength) return

        onSubmitValue({ name: trimmedValue }, refinerId)
        setInputValue('')
    }

    const onKeyDown = e => {
        if (e.key === 'Enter') submitValue()
    }

    const onClickClear = () => {
        setInputValue('')
    }

    return (
        <div className="ul-card -app">
            <div
                className="ul-card__item -bordered ul-card__head cursor-pointer s-refiner-height s-container-text"
                onClick={() => setIsShow(prevState => !prevState)}
            >
                <span className="font-size-14 font-weight-semi-bold">{refinerLabel}</span>
                <span className="float-right">
                    <FontAwesomeIcon icon={isShow ? faCaretDown : faCaretRight} />
                </span>
            </div>

            {isShow && (
                <div
                    className="ul-card__item ul-card__body s-select-container"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem',
                        backgroundColor: '#F8F9FA',
                        height: '2.75rem',
                        borderRadius: '0.25rem',
                        border: '1px solid #C7CCCF'
                    }}
                >
                    <span className="p-input-icon-right" style={{ flex: '1 1 auto' }}>
                        <FontAwesomeIcon
                            icon={faSearch}
                            className="cursor-pointer"
                            onClick={submitValue}
                        />
                        <InputText
                            className="w-100"
                            style={{ fontSize: '0.8rem', padding: '0.35rem 1.75rem 0.35rem 0.5rem', border: '1px solid #C7CCCF' }}
                            value={inputValue}
                            placeholder={placeHolder ?? `Enter minimum of "${minLength}" characters`}
                            onChange={e => setInputValue(e.target.value)}
                            onKeyDown={onKeyDown}
                        />
                    </span>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="cursor-pointer"
                        size="lg"
                        onClick={onClickClear}
                    />
                </div>
            )}
        </div>
    )
}

export default InputRefiner
